export default "__VITE_ASSET__CbCCGv4P__"